import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { EdituserPage } from "../edituser/edituser";
/**
 * Generated class for the RicercautentiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ricercautenti',
  templateUrl: 'ricercautenti.html',
})
export class RicercautentiPage {
  public searchTerm;
  utenti: string[];
  errorMessage: string;
  link;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider

  ) {

    this.searchTerm=navParams.get('searchTerm');
    if(this.searchTerm!=null){
     this.setFilteredItems();
    }
  }

  setFilteredItems() {
    console.log(this.searchTerm);
    if (this.searchTerm.length > 2) {
      this.rest.searcUserAdmin(this.searchTerm).subscribe(
        utenti => this.utenti = utenti,
        error => this.errorMessage = <any>error);
      if (this.utenti != null) {
        this.LoadData();
      }
    }
  }
  public LoadData() {
    console.log("LoadData this.utenti:" + JSON.stringify(this.utenti));

    console.log("LoadData");

  }
  openEditUtentePage(utente) {

    this.navCtrl.push(EdituserPage, { userAdmin: utente ,searchTerm:this.searchTerm});


  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RicercautentiPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/ricercautenti/ricercautenti.ts